import { render, staticRenderFns } from "./SelectDepartment.vue?vue&type=template&id=b129fc60&"
import script from "./SelectDepartment.vue?vue&type=script&lang=ts&"
export * from "./SelectDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports